import React, { useState } from 'react';
import { FormikValues, useFormik } from 'formik';

import {
  ConfirmationTypes,
  getBookedPharmacistDetails,
  pharmacistBookingDetails,
  PharmacyLegendVariant,
  updateTimings,
} from '@pharmaplan/common';

import UpdateDateTimeRange from '../../components/SelfService/WorkshiftSummary/UpdateDateTimeRange';
import Validator from '../../components/SelfService/WorkshiftSummary/Validator';
import { MomentTimeFormats, OutcomeModalTypes } from '../../helpers/Constants';
import ConfirmationModal from '../../components/Modals/ConfirmationModal';
import { resetDialog, setDialog } from '../../reducers/dialogReducer';
import { appendTimeToDate } from '../../helpers/workshift/functions';
import OutcomeModal from '../../components/Modals/OutcomeModal';
import { useAppDispatch } from '../useAppDispatch';
import { useAppSelector } from '../useAppSelector';
import strings from '../../localization';

const { fullDate } = MomentTimeFormats;
const { updateTiming } = ConfirmationTypes;
const { updateTiming: updateSuccess } = OutcomeModalTypes;

const useUpdateBookedTiming = (id: string) => {
  const dispatch = useAppDispatch();
  const [show, setShow] = useState(false);

  const pharmacistDets = useAppSelector(pharmacistBookingDetails);
  const { startDate, endDate } = pharmacistDets ?? {};

  const handleSubmit = (values: FormikValues) => {
    const { startTime, endTime } = values ?? {};

    dispatch(
      updateTimings({
        bookingId: id,
        startDate: appendTimeToDate(startDate, startTime).toFormat(fullDate),
        endDate: appendTimeToDate(endDate, endTime).toFormat(fullDate),
      }),
    );
  };

  const formik = useFormik({
    initialValues: {
      startTime: startDate,
      endTime: endDate,
    },

    onSubmit: handleSubmit,
    validationSchema: Validator(),
  });

  const confirmAction = () => {
    dispatch(
      setDialog({
        heading: {
          title: '',
        },
        Component: (
          <ConfirmationModal
            type={updateTiming}
            confirmAction={() => {
              dispatch(resetDialog());
              setShow(true);
            }}
          />
        ),
        showCloseButton: false,
      }),
    );
  };

  const showUpdateTimingSuccessModal = () => {
    dispatch(
      setDialog({
        heading: {
          title: '',
        },
        Component: (
          <OutcomeModal
            type={updateSuccess}
            message={strings.timingsUpdatedSuccessfully}
            showCloseButton
          />
        ),
        showCloseButton: false,
      }),
    );
  };

  const handleDiscardUpdated = () => {
    setShow(false);
  };

  const getPharmacist = () => {
    dispatch(
      getBookedPharmacistDetails({
        id,
        eventType: PharmacyLegendVariant.booked,
      }),
    );
  };

  const dateTime = show ? <UpdateDateTimeRange formik={formik} /> : null;

  return {
    dateTime,
    showUpdateTimingSuccessModal,
    confirmAction,
    show,
    formikHandleSubmit: formik.handleSubmit,
    handleDiscardUpdated,
    getPharmacist,

  };
};

export default useUpdateBookedTiming;
